export default "/img/401.png"